import { useTogglePopoverModal } from '@lessonup/client-integration';
import {
  PinModalPopover,
  PlayerBarBottom,
  PlayerBarBottomNavigation,
  PlayerBarBottomSection,
} from '@lessonup/players-modern';
import { useModal } from '@lessonup/ui-components';
import React, { useRef } from 'react';
import { useBoolean } from 'usehooks-ts';
import { PlayerBarBottomPositioning } from '../../../../components/PlayerBar/PlayerBarBottom/components/PlayerBarBottomPositioning';
import { usePlayerTranslation } from '../../hooks/usePlayerTranslation';
import { PlayerBarBottomHandlerProps } from './PlayerBarBottomHandler.utils';

export const PreviewPlayerBarBottomHandler: React.FC<PlayerBarBottomHandlerProps> = ({
  onNextClick,
  onPreviousClick,
  activePinId,
  pins,
  showLabels,
  navState,
  onPinClick,
  getPinThemeById,
}) => {
  const minimizedBar = useBoolean(false);
  const mirroredBar = useBoolean(false);
  const isMirrored = minimizedBar.value && mirroredBar.value;
  const slidesButtonRef = useRef<HTMLButtonElement>(null);
  const { t } = usePlayerTranslation();
  const pinModal = useModal(PinModalPopover);

  const [slideButtonHandleClick, slideButtonHandleMouseDown, isSlidesModalVisible] = useTogglePopoverModal(pinModal, {
    customModalShow: () =>
      pins &&
      pinModal.show({
        pins,
        parentSelector: () => slidesButtonRef.current,
        activePinId,
        direction: 'top',
        modalAnchor: 'center',
        onPinClick,
        getPinThemeByPinId: getPinThemeById,
      }),
  });

  return (
    <PlayerBarBottom minimized={minimizedBar.value} mirrored={isMirrored}>
      <PlayerBarBottomSection mirrored={isMirrored}>
        <PlayerBarBottomNavigation
          onNextClick={onNextClick}
          onPreviousClick={onPreviousClick}
          onSlidesClick={slideButtonHandleClick}
          onSlidesMouseDown={slideButtonHandleMouseDown}
          slidesButtonRef={slidesButtonRef}
          labelPrevious={t('labels.previous')}
          labelSlides={t('labels.slides')}
          labelNext={t('labels.next')}
          index={pins.findIndex((p) => p.id === activePinId) + 1}
          total={pins.length}
          hasPrevious={navState.hasPrevious}
          hasNext={navState.hasNext}
          slidesActive={isSlidesModalVisible}
        />
      </PlayerBarBottomSection>
      <PlayerBarBottomSection mirrored={isMirrored}>
        <PlayerBarBottomPositioning
          mirrored={isMirrored}
          minimized={minimizedBar.value}
          toggleMirror={mirroredBar.toggle}
          toggleMinimize={minimizedBar.toggle}
          showLabels={showLabels}
        />
      </PlayerBarBottomSection>
    </PlayerBarBottom>
  );
};
